"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PATIENT_COVERAGE_RESPONSE_EXAMPLE = void 0;
exports.PATIENT_COVERAGE_RESPONSE_EXAMPLE = {
    id: '44444444-4444-4444-4444-444444444444',
    tenantId: '11111111-1111-1111-1111-111111111111',
    patientId: '22222222-2222-2222-2222-222222222222',
    payerId: '88888888-8888-8888-8888-888888888888',
    administeredByPayerId: null,
    policyNumberMasked: '********1234',
    groupNumber: 'ACME-CORP-2026',
    relationshipToSubscriberId: 'lookup-self',
    coveragePriority: 'PRIMARY',
    validFrom: '2026-01-01T00:00:00.000Z',
    validTo: null,
    status: 'ACTIVE',
    cashlessEligible: true,
    preAuthRequired: false,
    verificationStatus: 'VERIFIED',
    verifiedAt: '2026-01-01T00:00:00.000Z',
    planId: null,
    sumInsuredAmount: null,
    version: 1,
    lockVersion: 1,
    createdAt: '2026-01-01T00:00:00.000Z',
    updatedAt: '2026-01-01T00:00:00.000Z',
};
//# sourceMappingURL=coverage.response.js.map